import React from 'react';
import { useCrossTenantCheck } from '../../../../hooks';
import { t } from '../../../../services';
import { CrossTenantIcon } from '../CrossTenantIcon';
export var VisibilityCell = function (_a) {
    var record = _a.record;
    var isCrossTenant = useCrossTenantCheck().isCrossTenant;
    var visibilityLabel = t(record.isPrivate
        ? 'lists.item.private'
        : 'lists.item.shared');
    return (React.createElement(React.Fragment, null,
        visibilityLabel,
        isCrossTenant(record.entityTypeId) && React.createElement(CrossTenantIcon, null)));
};
